{
  "name": "fuse-frontend",
  "version": "2.38.0",
  "private": true,
  "description": "Frontend for the FuSE 2.0 app",
  "scripts": {
    "build": "yarn lint && parcel build public/index.html",
    "build:test": "parcel build public/index.html",
    "serve:test": "yarn build:test && serve -s dist -l 1234",
    "dev": "DEBUG=fuse* parcel public/index.html",
    "start": "parcel public/index.html",
    "start:dev": "env-cmd -f .env.development.local yarn start",
    "start:local": "env-cmd -f .env.local yarn start",
    "clean": "rm -rf .parcel-cache",
    "test": "playwright test",
    "lint": "eslint src --ext .ts,.tsx --max-warnings 0",
    "lint:fix": "eslint src --ext .ts,.tsx --fix",
    "typecheck": "tsc --noEmit",
    "format": "prettier --write \"src/**/*.{ts,tsx,js,jsx,json,md}\"",
    "check-format": "prettier --check \"src/**/*.{ts,tsx,js,jsx,json,md}\"",
    "validate": "yarn lint && yarn check-format && yarn test"
  },
  "engines": {
    "node": "24.22.1"
  },
  "browserslist": "> 0.5%, last 2 versions, not dead",
  "dependencies": {
    "@sentry/react": "^8.26.0",
    "@tanstack/react-query": "^5.96.2",
    "apexcharts": "^3.44.1",
    "dayjs": "^1.11.10",
    "debug": "^4.3.4",
    "driver.js": "^1.4.0",
    "env-cmd": "10",
    "grommet": "^2.32.0",
    "grommet-icons": "^4.11.0",
    "html2canvas": "^1.4.1",
    "i18next": "^23.10.0",
    "i18next-browser-languagedetector": "^7.2.0",
    "jsonwebtoken": "^9.0.0",
    "jspdf": "^3.0.0",
    "leaflet": "^1.9.4",
    "mobx": "^6.9.0",
    "mobx-react-lite": "^4.1.0",
    "react": "^19.0.0",
    "react-apexcharts": "^1.4.1",
    "react-dom": "^19.0.0",
    "react-error-boundary": "^4.0.4",
    "react-i18next": "^14.0.5",
    "react-leaflet": "^5.0.0",
    "react-router-dom": "^6.11.2",
    "react-toastify": "^11",
    "styled-components": "5.3.10"
  },
  "devDependencies": {
    "@parcel/css": "^1.14.0",
    "@parcel/transformer-svg-react": "^2.10.2",
    "@playwright/test": "^1.45.3",
    "@trivago/prettier-plugin-sort-imports": "^4.3.0",
    "@types/debug": "^4.1.12",
    "@types/google.maps": "^3.58.1",
    "@types/jsonwebtoken": "^9.0.2",
    "@types/leaflet": "^1.9.8",
    "@types/node": "24.4.0",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "@typescript-eslint/eslint-plugin": "^5.59.6",
    "@typescript-eslint/parser": "^5.59.6",
    "buffer": "^5.5.0",
    "crypto-browserify": "^3.12.0",
    "eslint": "^8.49.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-jsx-a11y": "^6.7.1",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-react": "^7.32.2",
    "eslint-plugin-react-hooks": "^4.6.0",
    "events": "^3.1.0",
    "parcel": "^2.10.2",
    "prettier": "^3.0.3",
    "process": "^0.11.10",
    "react-is": "^19.0.0",
    "serve": "^14.2.0",
    "stream-browserify": "^3.0.0",
    "svgo": "^3",
    "typescript": "5.0.4",
    "url": "^0.11.0",
    "util": "^0.12.3",
    "xlsx": "^0.18.5"
  },
  "resolutions": {
    "csstype": "^3.2.3"
  }
}
